var map = {
	"./beige/akzonobel.svg": 2378,
	"./blue/akzonobel.svg": 2379,
	"./cetabever/akzonobel.svg": 2380,
	"./heritage/akzonobel.svg": 2381,
	"./painters/akzonobel.svg": 2382,
	"./woodcare/akzonobel.svg": 2383
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 565;



//////////////////
// WEBPACK FOOTER
// ./shared/components/Header/assets ^\.\/.*\/akzonobel\.svg$
// module id = 565
// module chunks = 0